import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import "./StoreDetails.css";
import Loader from "../../Loader/Loader";
import {
  vendordetails,
  executeStoreAction,
  blockuser,
  productdelete,
} from "../../service/Mainservice";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import StarIcon from "@mui/icons-material/Star";
import BlockIcon from "@mui/icons-material/Block";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import FeaturedIcon from "@mui/icons-material/StarBorder";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Modal from "../User/Model";
import Deletepopup from "./Aresure";
import { Editproduct } from "./Editproduct";
import ImageSlider from "./Imageslider";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
// ✅ NEW: Chat imports
import ChatIcon from "@mui/icons-material/Chat";
import ChatComponent from "../../component/Chat/ChatComponent"; // ✅ NEW

const StoreDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const storeId = location.state?.item?.id || location.state?.id;

  const [loading, setLoading] = useState(true);
  const [store, setStore] = useState(null);
  const [activeTab, setActiveTab] = useState("profile");
  const [expandedOrders, setExpandedOrders] = useState({});

  // Product management
  const [isdelete, setisdelete] = useState(false);
  const [isedit, setisedit] = useState(false);
  const [p_id, setp_id] = useState();
  const [productInfo, setProductInfo] = useState();

  // Modal states
  const [modalOpen, setModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [modalData, setModalData] = useState({});

  useEffect(() => {
    if (storeId) {
      fetchProfile();
    } else {
      navigate("/Stores_List");
    }
  }, [storeId]);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await vendordetails(storeId);
      setStore(res.data.data);
    } catch (error) {
      console.error(error);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      } else {
        alert("Failed to load store profile");
      }
    } finally {
      setLoading(false);
    }
  };

  // ----- Action Handlers -----
  const handleAction = async (action, value = null) => {
    try {
      await executeStoreAction(storeId, action, value);
      const actionMap = {
        pause: "Store paused",
        resume: "Store resumed",
        suspend: "Store suspended",
        rate_change: `Commission updated to ${value}%`,
        edit_fulfillment: `Fulfillment option changed to "${value}"`,
        edit_minimum_order: "Minimum order settings updated",
      };
      alert(actionMap[action] || "Action completed");
      fetchProfile();
    } catch (error) {
      alert("Failed to execute action");
    }
    setModalOpen(false);
  };

  const handleSendMessage = async () => {
    const message = modalData.message;
    if (!message) {
      alert("Please enter a message");
      return;
    }
    try {
      // await sendMessageToStore(storeId, message);
      // alert("Message sent successfully");
    } catch (error) {
      alert("Failed to send message");
    }
    setModalOpen(false);
  };

  const handleToggleFeatured = async () => {
    try {
      alert("Featured status toggled (mock)");
      fetchProfile();
    } catch (error) {
      alert("Failed to toggle featured");
    }
  };

  const openModal = (action, initialData = {}) => {
    setModalAction(action);
    setModalData(initialData);
    setModalOpen(true);
  };

  const toggleOrderExpand = (orderId) => {
    setExpandedOrders((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  // ----- Modal Content -----
  const renderModalContent = () => {
    switch (modalAction) {
      case "pause":
        return (
          <div>
            <h3>Pause Store</h3>
            <p>Store will not accept new orders until resumed.</p>
            <div className="modal_actions">
              <button
                onClick={() => handleAction("pause")}
                className="btn_primary"
              >
                Pause
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "resume":
        return (
          <div>
            <h3>Resume Store</h3>
            <p>Store will start accepting orders again.</p>
            <div className="modal_actions">
              <button
                onClick={() => handleAction("resume")}
                className="btn_primary"
              >
                Resume
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "suspend":
        return (
          <div>
            <h3>Suspend Store</h3>
            <p>Store will be temporarily suspended.</p>
            <div className="modal_field">
              <label>Reason (optional)</label>
              <textarea
                value={modalData.reason || ""}
                onChange={(e) =>
                  setModalData({ ...modalData, reason: e.target.value })
                }
                className="modal_textarea"
                rows="3"
              />
            </div>
            <div className="modal_actions">
              <button
                onClick={() => handleAction("suspend")}
                className="btn_danger"
              >
                Suspend
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "rate_change":
        return (
          <div>
            <h3>Edit Commission Rate</h3>
            <div className="modal_field">
              <label>Commission Rate (%)</label>
              <input
                type="number"
                min="0"
                max="100"
                step="0.5"
                value={modalData.rate || store?.profile?.commissionRate || ""}
                onChange={(e) =>
                  setModalData({ ...modalData, rate: e.target.value })
                }
                className="modal_input"
              />
            </div>
            <div className="modal_actions">
              <button
                onClick={() => handleAction("rate_change", modalData.rate)}
                className="btn_primary"
              >
                Update
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "minimum_order":
        return (
          <div>
            <h3>Edit Minimum Order</h3>
            <div className="modal_field">
              <label>
                <input
                  type="checkbox"
                  checked={Boolean(modalData.enabled)}
                  onChange={(e) =>
                    setModalData({ ...modalData, enabled: e.target.checked })
                  }
                />{" "}
                Require a minimum order amount
              </label>
            </div>
            <div className="modal_field">
              <label htmlFor="minimum-order-amount">Minimum order amount</label>
              <input
                id="minimum-order-amount"
                type="number"
                min="0"
                step="0.01"
                value={modalData.amount ?? ""}
                onChange={(e) =>
                  setModalData({ ...modalData, amount: e.target.value })
                }
                className="modal_input"
              />
            </div>
            <div className="modal_actions">
              <button
                onClick={() => {
                  const amount = Number(modalData.amount);
                  if (!Number.isFinite(amount) || amount < 0) {
                    alert("Enter a valid minimum order amount");
                    return;
                  }
                  handleAction("edit_minimum_order", {
                    enabled: Boolean(modalData.enabled),
                    amount,
                  });
                }}
                className="btn_primary"
              >
                Update
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "message":
        return (
          <div>
            <h3>Send Message</h3>
            <textarea
              placeholder="Type your message..."
              value={modalData.message || ""}
              onChange={(e) =>
                setModalData({ ...modalData, message: e.target.value })
              }
              className="modal_textarea"
              rows="4"
            />
            <div className="modal_actions">
              <button onClick={handleSendMessage} className="btn_primary">
                Send
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      case "fulfillment":
        return (
          <div>
            <h3>Edit Fulfillment Options</h3>
            <p>
              Current: <strong>{modalData.current || "both"}</strong>
            </p>
            <div className="modal_field">
              <label>Select fulfillment type:</label>
              <div className="radio_group">
                <label>
                  <input
                    type="radio"
                    name="fulfillment"
                    value="pickup"
                    checked={modalData.selected === "pickup"}
                    onChange={(e) =>
                      setModalData({ ...modalData, selected: e.target.value })
                    }
                  />
                  Pickup Only
                </label>
                <label>
                  <input
                    type="radio"
                    name="fulfillment"
                    value="delivery"
                    checked={modalData.selected === "delivery"}
                    onChange={(e) =>
                      setModalData({ ...modalData, selected: e.target.value })
                    }
                  />
                  Delivery Only
                </label>
                <label>
                  <input
                    type="radio"
                    name="fulfillment"
                    value="both"
                    checked={modalData.selected === "both"}
                    onChange={(e) =>
                      setModalData({ ...modalData, selected: e.target.value })
                    }
                  />
                  Both
                </label>
              </div>
            </div>
            <div className="modal_actions">
              <button
                onClick={() =>
                  handleAction("edit_fulfillment", modalData.selected)
                }
                className="btn_primary"
              >
                Update
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="btn_secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  // Product handlers
  const handleProductDelete = async () => {
    try {
      await productdelete(p_id);
      fetchProfile();
      setisdelete(false);
    } catch (error) {
      alert("Failed to delete product");
    }
  };

  // ----- Render -----
  if (loading) return <Loader />;
  if (!store) return <div className="error_msg">Store not found</div>;

  const { profile, catalog, orderHistory, ratingsAndReviews, earnings } = store;

  // Status helpers
  const isPaused = profile.pauseNewOrders;
  const isSuspended = profile.isBlocked;
  const isFeatured = profile.isFeatured;

  let statusBadge = "active";
  let statusText = "Open";
  if (isSuspended) {
    statusBadge = "banned";
    statusText = "Suspended";
  } else if (!profile.isStoreOpen) {
    statusBadge = "closed";
    statusText = "Closed";
  } else if (isPaused) {
    statusBadge = "paused";
    statusText = "Paused";
  } else if (profile.busyMode) {
    statusBadge = "busy";
    statusText = "Busy";
  } else {
    statusBadge = "active";
    statusText = "Open";
  }

  // Action buttons based on active tab
  const renderActionButtons = () => {
    switch (activeTab) {
      case "profile":
        return (
          <>
            {isPaused ? (
              <button
                className="action_btn"
                onClick={() => openModal("resume")}
              >
                <PlayArrowIcon /> Resume
              </button>
            ) : (
              <button className="action_btn" onClick={() => openModal("pause")}>
                <PauseIcon /> Pause
              </button>
            )}
            <button className="action_btn" onClick={() => openModal("suspend")}>
              <BlockIcon /> Suspend
            </button>
            <button
              className="action_btn"
              onClick={() => openModal("rate_change")}
            >
              <EditIcon /> Edit Commission
            </button>
            <button
              className="action_btn"
              onClick={() =>
                openModal("fulfillment", {
                  current: profile.fulfillmentOption || "both", // fallback
                  selected: profile.fulfillmentOption || "both",
                })
              }
            >
              <StorefrontIcon /> Fulfillment Options
            </button>
            <button
              className="action_btn"
              onClick={() =>
                openModal("minimum_order", {
                  enabled: Boolean(profile.minOrderEnabled),
                  amount: profile.minOrderAmount ?? 0,
                })
              }
            >
              <ShoppingBasketIcon /> Minimum Order
            </button>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="storedetails_container">
        {/* Header */}
        <div className="details_header">
          <button className="back_btn" onClick={() => navigate("/Stores_List")}>
            ← Back to Stores
          </button>
          <h2>Store Details</h2>
        </div>

        {/* Profile Summary */}
        <div className="profile_summary">
          <div className="avatar">
            {profile.shopImage ? (
              <img src={profile.shopImage} alt={profile.shopName} />
            ) : (
              <StorefrontIcon style={{ fontSize: 60 }} />
            )}
          </div>
          <div className="summary_info">
            <h3>{profile.shopName}</h3>
            <p>
              <PersonOutlineIcon fontSize="small" /> {profile.fullName}
            </p>
            <p>
              <EmailIcon fontSize="small" /> {profile.email}
            </p>
            <p>
              <PhoneIcon fontSize="small" /> {profile.mobilenumber}
            </p>
            <p>
              Status:{" "}
              <span className={`badge ${statusBadge}`}>{statusText}</span>
              {isFeatured && (
                <span className="badge featured">⭐ Featured</span>
              )}
            </p>
          </div>
          <div className="summary_stats">
            <div>
              <strong>{catalog?.length || 0}</strong>
              <span>Products</span>
            </div>
            <div>
              <strong>{orderHistory?.length || 0}</strong>
              <span>Orders</span>
            </div>
            <div>
              <strong>${earnings?.totalEarnings || 0}</strong>
              <span>Total Earnings</span>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs">
          <button
            className={activeTab === "profile" ? "tab_active" : ""}
            onClick={() => setActiveTab("profile")}
          >
            <StorefrontIcon /> Profile
          </button>
          <button
            className={activeTab === "products" ? "tab_active" : ""}
            onClick={() => setActiveTab("products")}
          >
            <StorefrontIcon /> Products ({catalog?.length || 0})
          </button>
          <button
            className={activeTab === "orders" ? "tab_active" : ""}
            onClick={() => setActiveTab("orders")}
          >
            <ReceiptIcon /> Orders ({orderHistory?.length || 0})
          </button>
          <button
            className={activeTab === "earnings" ? "tab_active" : ""}
            onClick={() => setActiveTab("earnings")}
          >
            <AttachMoneyIcon /> Earnings
          </button>
          <button
            className={activeTab === "reviews" ? "tab_active" : ""}
            onClick={() => setActiveTab("reviews")}
          >
            <StarIcon /> Reviews ({ratingsAndReviews?.length || 0})
          </button>
          {/* ✅ NEW: Messages Tab */}
          <button
            className={activeTab === "messages" ? "tab_active" : ""}
            onClick={() => setActiveTab("messages")}
          >
            <ChatIcon /> Messages
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab_content">
          {activeTab === "profile" && (
            <div className="profile_info">
              <div className="info_section">
                <h4>Store Details</h4>
                <div className="detail_row">
                  <span>Shop Name</span> <strong>{profile.shopName}</strong>
                </div>
                <div className="detail_row">
                  <span>Owner</span> <strong>{profile.fullName}</strong>
                </div>
                <div className="detail_row">
                  <span>Email</span> <strong>{profile.email}</strong>
                </div>
                <div className="detail_row">
                  <span>Phone</span> <strong>{profile.mobilenumber}</strong>
                </div>
                <div className="detail_row">
                  <span>Address</span>{" "}
                  <strong>{profile.address || "N/A"}</strong>
                </div>
                <div className="detail_row">
                  <span>About</span>{" "}
                  <strong>{profile.shopAbout || "N/A"}</strong>
                </div>
              </div>
              <div className="info_section">
                <h4>Operating Hours</h4>
                <div className="detail_row">
                  <span>Pickup Start</span>
                  <strong>{profile.BuyerPickUpStartTime || "N/A"}</strong>
                </div>
                <div className="detail_row">
                  <span>Pickup End</span>
                  <strong>{profile.BuyerPickUpEndTime || "N/A"}</strong>
                </div>
              </div>
              <div className="info_section">
                <h4>Commission & Status</h4>
                <div className="detail_row">
                  <span>Commission Rate</span>{" "}
                  <strong>{profile.commissionRate || 0}%</strong>
                </div>
                <div className="detail_row">
                  <span>Minimum Order</span>{" "}
                  <strong>
                    {profile.minOrderEnabled
                      ? `$${Number(profile.minOrderAmount || 0).toFixed(2)}`
                      : "Disabled"}
                  </strong>
                </div>
                <div className="detail_row">
                  <span>Verified</span>{" "}
                  <strong>{profile.isVerify ? " Yes" : " No"}</strong>
                </div>
              </div>
            </div>
          )}

          {activeTab === "products" && (
            <div className="product_catalog">
              {catalog?.length ? (
                <div className="product_grid">
                  {catalog.map((product) => (
                    <div className="product_card" key={product.id}>
                      <ImageSlider images={product.images || []} />
                      <div className="product_edit">
                        <BorderColorRoundedIcon
                          onClick={() => {
                            setisedit(true);
                            setProductInfo(product);
                          }}
                        />
                        <DeleteRoundedIcon
                          onClick={() => {
                            setisdelete(true);
                            setp_id(product.id);
                          }}
                        />
                      </div>
                      <div className="product_data">
                        <div className="product_name_price">
                          <div>
                            <p className="product_name">{product.name}</p>
                            <p className="product_about">{product.about}</p>
                          </div>
                          <p className="product_price">${product.price}</p>
                        </div>
                        <p className="product_info">
                          Category: <span>{product.categoryName}</span>
                        </p>
                        <p className="product_info">
                          Subcategory: <span>{product.subcategoryName}</span>
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="no_data">No products in catalog.</p>
              )}
            </div>
          )}

          {activeTab === "orders" && (
            <div className="order_history">
              {orderHistory?.length ? (
                orderHistory.map((order) => (
                  <div key={order.id} className="order_card">
                    <div
                      className="order_header"
                      onClick={() => toggleOrderExpand(order.id)}
                    >
                      <div className="order_summary">
                        <span className="order_number">
                          #{order.orderNumber || "N/A"}
                        </span>
                        <span className="order_date">
                          {new Date(order.createdAt).toLocaleDateString()}
                        </span>
                        <span className="order_total">${order.totalPrice}</span>
                        <span
                          className={`badge ${order.orderStatus.toLowerCase()}`}
                        >
                          {order.orderStatus}
                        </span>
                      </div>
                      <button className="expand_btn">
                        {expandedOrders[order.id] ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </button>
                    </div>
                    {expandedOrders[order.id] && (
                      <div className="order_details">
                        <p>
                          <strong>Customer:</strong>{" "}
                          {order.customer?.name || "N/A"}
                        </p>
                        <p>
                          <strong>Address:</strong>{" "}
                          {order.shippingAddress || "N/A"}
                        </p>
                        <p>
                          <strong>Payment:</strong> {order.paymentMethod}
                        </p>
                        <p>
                          <strong>Items:</strong> {order.products?.length || 0}
                        </p>
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p className="no_data">No orders yet.</p>
              )}
            </div>
          )}

          {activeTab === "earnings" && (
            <div className="earnings">
              <div className="earnings_summary">
                <div className="earning_stat">
                  <span>Total Earnings</span>
                  <strong>${earnings?.totalEarnings || 0}</strong>
                </div>
                <div className="earning_stat">
                  <span>Pending Earnings</span>
                  <strong>${earnings?.pendingEarnings || 0}</strong>
                </div>
              </div>
              <div className="payouts">
                <h4>Payout History</h4>
                {earnings?.payouts?.length ? (
                  earnings.payouts.map((payout, i) => (
                    <div key={i} className="payout_row">
                      <span>{new Date(payout.date).toLocaleDateString()}</span>
                      <span>${payout.amount}</span>
                      <span className={`badge ${payout.status.toLowerCase()}`}>
                        {payout.status}
                      </span>
                    </div>
                  ))
                ) : (
                  <p className="no_data">No payouts yet.</p>
                )}
              </div>
            </div>
          )}

          {activeTab === "reviews" && (
            <div className="reviews">
              {ratingsAndReviews?.length ? (
                ratingsAndReviews.map((review) => (
                  <div key={review.id} className="review_item">
                    <div className="review_header">
                      <strong>{review.customerName || "Anonymous"}</strong>
                      <span>⭐ {review.rating}</span>
                    </div>
                    <p>{review.comment}</p>
                    <small>
                      {new Date(review.createdAt).toLocaleDateString()}
                    </small>
                  </div>
                ))
              ) : (
                <p className="no_data">No reviews yet.</p>
              )}
            </div>
          )}

          {/* ✅ NEW: Messages Content */}
          {activeTab === "messages" && (
            <div className="messages_tab">
              <ChatComponent
                userId={storeId}
                userType="vendor"
                title={`Chat with ${profile.shopName}`}
              />
            </div>
          )}
        </div>

        {/* Actions Bar */}
        <div className="actions_bar">{renderActionButtons()}</div>
      </div>

      {/* Modals */}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        {renderModalContent()}
      </Modal>

      <Deletepopup
        isOpen={isdelete}
        setisOpen={setisdelete}
        handledelete={handleProductDelete}
      />

      {isedit && (
        <Editproduct
          isopen={isedit}
          setisopen={setisedit}
          items={productInfo}
          getdata={fetchProfile}
        />
      )}

      {loading && <Loader />}
    </>
  );
};

export default StoreDetails;
